import { render, staticRenderFns } from "./RoofAccess.vue?vue&type=template&id=d948db1a"
import script from "./RoofAccess.vue?vue&type=script&lang=js"
export * from "./RoofAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports